export default {
  "animatedIcon": "_animatedIcon_820u0_1"
};import "ni:sha-256;MZHhxUFFKC3GIOZykrR2GHr-V1NcRfo-ktOgUBuENgM";